export class ConfirmationWithCommentWarningDialogData {
  title: string;
  displayText: string;
  additionalDisplayText?: string;
  confirmBtnName: string;
  cancelBtnName: string;
  inputPlaceholder: string;
  validationMessage: string;
  isConfirmed = false;
  minLength?: number;
  maxLength?: number;

  constructor(
    title: string,
    displayText: string,
    additionalDisplayText = '',
    confirmBtnName: string,
    cancelBtnName: string,
    inputPlaceholder: string,
    validationMessage: string,
    isConfirmed = false,
    minLength = 25,
    maxLength = 1000
  ) {
    this.title = title;
    this.displayText = displayText;
    this.additionalDisplayText = additionalDisplayText;
    this.confirmBtnName = confirmBtnName;
    this.cancelBtnName = cancelBtnName;
    this.inputPlaceholder = inputPlaceholder;
    this.validationMessage = validationMessage;
    this.isConfirmed = isConfirmed;
    this.minLength = minLength;
    this.maxLength = maxLength;
  }
};
